import { createBooleanTagManager } from '../../utils/createBooleanTagManager';

export const notLastFloorTagManager = createBooleanTagManager({
  jsonQueryKey: 'not_last_floor',
  trueLabel: 'Не последний этаж',
  falseLabel: 'Только последний этаж',
  id: 'notLastFloor',
});
